var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.bp && _vm.press.length)?_c('div',{staticClass:"press"},[(_vm.bp.lg)?_c('press-row',{attrs:{"reverse":_vm.reverse,"press":_vm.items}}):_c('press-gallery',{attrs:{"press":_vm.items}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }